angular.module('suggested_links_module').factory('SuggestedLinksFactory', ['$resource', function ($resource) {
    return $resource('/api/v2.0/articles/suggested-links/:slug/', {slug: '@slug'}, {
        query: {
            isArray: false
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        get: {
            method: 'GET'
        },
        delete: {
            method: 'DELETE'
        }
    });
}]);